/**
 * httpMethods.js
 *
 * Defines HTTP method constants for use in API calls throughout the application.
 * Ensures consistency and prevents typos in HTTP method strings.
 */

export const GET = 'GET';
export const POST = 'POST'; // Corrected from 'PUT' to 'POST'
export const PUT = 'PUT';
export const PATCH = 'PATCH';
export const DELETE = 'DELETE';
